import Tools from "./JNSTools";

class Analysis {
  constructor(projid, creds) {
    this.projid = projid;
    this.creds = creds;
  }

  async getTaskAnalysis() {
    return await this.analyzeTasks();
  }

  async analyzeTasks() {
    const settings = JSON.parse(localStorage.getItem("oadaSettings"));
    const SLIGHTLY_THRESHOLD = parseFloat(settings.thresholds.t1);
    const MODERATELY_THRESHOLD = parseFloat(settings.thresholds.t2);
    const urlString = Tools.getInstanceUrl(this.creds);
    const authString = Tools.getXmlBodyAuthString(this.creds);

    let message;

    const requestString =
      authString +
      '<Read type="Projecttask" method="equal to" limit="1000" enable_custom="1"><Projecttask><projectid>' +
      this.projid +
      "</projectid></Projecttask></Read></request>";
    const rawTaskRecs = await Tools.fetchPost(
      requestString,
      urlString,
      "Projecttask",
    );

    if (rawTaskRecs.xml.length > 0) {
      const filteredObjects = Tools.xmlToArray(rawTaskRecs.xml);

      // actual analysis loop
      for (let x = 0; x < filteredObjects.length; x++) {
        let f_obj = filteredObjects[x];
        if (f_obj.is_a_phase != 1 && f_obj.oada_exclude_from_analysis__c != 1) {
          f_obj.Task = f_obj.name; // for compatability w/report version
          f_obj.Task___Internal_id = f_obj.id; // for compatability w/report version
          f_obj.messageArray = [];
          const tempStartDateString =
            f_obj.starts != "00000000" ? f_obj.starts : f_obj.calculated_starts;
          const tempStartDateStringReformatted =
            tempStartDateString.substring(4) +
            "-" +
            tempStartDateString.substring(0, 2) +
            "-" +
            tempStartDateString.substring(2, 4);
          const tempStartDate = new Date(tempStartDateStringReformatted);
          const tempEndDateString =
            f_obj.fnlt_date != "00000000"
              ? f_obj.fnlt_date
              : f_obj.calculated_finishes;
          const tempEndDateStringReformatted =
            tempEndDateString.substring(4) +
            "-" +
            tempEndDateString.substring(0, 2) +
            "-" +
            tempEndDateString.substring(2, 4);
          const tempEndDate = new Date(
            tempEndDateStringReformatted.substring(0, 10),
          );

          const startDate = new Date(
            tempStartDate.getTime() + tempStartDate.getTimezoneOffset() * 60000,
          );
          const endDate = new Date(
            tempEndDate.getTime() + tempEndDate.getTimezoneOffset() * 60000,
          );
          const msSinceStart =
            new Date() - startDate > 0 ? new Date() - startDate : 0;

          const msTaskDuration = endDate - startDate;

          if (f_obj.oada_task_timesheet_hours__c == "") {
            f_obj.oada_task_timesheet_hours__c = 0;
          }
          f_obj.plannedLessActual =
            parseFloat(f_obj.planned_hours) -
            parseFloat(f_obj.oada_task_timesheet_hours__c);
          f_obj.percentOfPlanned =
            f_obj.planned_hours > 0
              ? Math.round(
                  (parseFloat(f_obj.oada_task_timesheet_hours__c) /
                    parseFloat(f_obj.planned_hours)) *
                    10000,
                ) / 100
              : 0;
          f_obj.expectedPercent =
            msTaskDuration > 0
              ? parseInt((msSinceStart / msTaskDuration) * 10000) / 100
              : 0;
          if (f_obj.expectedPercent > 100) {
            f_obj.expectedPercent = 100;
          }

          const pct = isNaN(parseInt(f_obj.percent_complete))
            ? 0
            : parseInt(f_obj.percent_complete);
          const pctDiff = Math.abs(pct - f_obj.expectedPercent);
          const higherLower =
            pct - f_obj.expectedPercent > 0 ? " higher than " : " lower than ";

          let differenceString;
          if (pctDiff < SLIGHTLY_THRESHOLD) {
            differenceString = "Gslightly";
          } else if (pctDiff < MODERATELY_THRESHOLD) {
            differenceString = "Ymoderately";
          } else {
            differenceString = "Rsignificantly";
          }

          if (f_obj.plannedLessActual < 0) {
            message =
              "This task's actual hours (" +
              f_obj.oada_task_timesheet_hours__c +
              ") |Rexceed| its planned hours (" +
              f_obj.planned_hours +
              ") by " +
              Math.abs(f_obj.plannedLessActual) +
              " hours.";
            f_obj.messageArray.push(message);
          } else if (f_obj.percentOfPlanned > 0) {
            message =
              "This task's |Yactual hours| (" +
              f_obj.oada_task_timesheet_hours__c +
              ") is " +
              f_obj.percentOfPlanned +
              "% of its planned hours (" +
              f_obj.planned_hours +
              ").";
            f_obj.messageArray.push(message);
          }

          if (pctDiff != 0) {
            message =
              "The percent complete (" +
              pct +
              "%) is |" +
              differenceString +
              higherLower +
              "|the expected percentage of " +
              f_obj.expectedPercent +
              "% based on the task's start and end dates.";
            f_obj.messageArray.push(message);
          }
        }
        /*if (f_obj.Task___Assigned_Users === null) {
            message = "There are |Rno users| assigned to this task.";
            f_obj.messageArray.push(message);
          }*/

        //console.log(f_obj.Task + ": " + JSON.stringify(f_obj.messageArray));
      }

      return filteredObjects;
    }
  }
}

export default Analysis;
